import { Grid2 as Grid, TextField } from "@mui/material";
import React from "react";
import { ServiceAgreementsInputs } from "@utils/BasicTypes";
import { ui } from "../../../../../../../../../../interfaces/interfaces";

const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const name = event.target.name as ServiceAgreementsInputs;
    ui[name] = value as never;
};

/**
 * Component for rendering a multiline text field for notes.
 *
 * @param {Object} props - Component props.
 * @param {string} props.note - Note value to be displayed in the text field.
 * @param {string} props.name - Name of the text field.
 * @returns {JSX.Element} - The rendered Notes component.
 */
export const Notes: React.FC<NotesProps> = ({ note, name }) => (
    <Grid
        size={{
            xs: 12,
            sm: 12
        }}>
        <TextField
            onChange={handleChange}
            id="filled-multiline-static"
            label="Exclusion Details"
            multiline
            rows={4}
            name={name}
            value={note}
            variant="outlined"
            fullWidth
        />
    </Grid>
);

type NotesProps = {
    note: string
    name: string
}